module.exports = __webpack_public_path__ + "static/media/020-_DSC8903.1024f750.jpg";